import React from 'react';
import { Translate, withLocalize } from "react-localize-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BbPopover from '../../common/popover';
import QuickReportRow from './quickReportRow';
import UnderlinedTitle from "../../common/underlinedTitle";

class QuickReportMonitoraTeaser extends React.Component {
    render() {
        return (this.props.data === undefined || this.props.data === null ? null : this.renderContent(this.props.data));
    }

    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    renderContent(data) {
        return (
            <div>
                <div className='columns is-desktop cards-fixed-height is-multiline is-centered'>
                    <div className='column is-5-fullhd is-5-widescreen is-12 has-text-centered ' >
                        <div className="box scrn-h-100 monitora-teaser-colored-card" style={{ padding: "0.5em" }}>
                            <div style={{ float: "right" }}>
                                <BbPopover title="Monitora" content={this.props.translate("Report.Monitora.Help")} placement="left" targetId="monitora-popover">
                                    <span href="#" className="icon-gray print-hidden" id="monitora-popover" style={{ cursor: "pointer" }}>
                                        <FontAwesomeIcon icon="question-circle" />
                                    </span>
                                </BbPopover>
                            </div>
                            <div style={{ padding: "0.75em" }}>
                                <UnderlinedTitle header={<Translate id='Report.Quick.MonitoraTeaser.TotalTitle' />} />
                                <div style={{ fontSize: "2em", fontWeight: "600", padding: "0.8em 0" }}>
                                    <span>{data.total}</span>
                                </div>
                                <span><Translate id='Report.Quick.MonitoraTeaser.DaysTitle' /> {data.days}  <Translate id='Report.Quick.MonitoraTeaser.Days' /></span>
                            </div>
                        </div>
                    </div>
                </div>
                {(data.total > 0) &&
                    <div className='columns is-desktop cards-fixed-height is-multiline is-centered'>
                        {this.renderTableCard(true, 'Report.Quick.MonitoraTeaser.SentimentTitle', [
                            { titleKey: "Report.Quick.MonitoraTeaser.Positive", value: data.sentiment.positive },
                            { titleKey: "Report.Quick.MonitoraTeaser.Negative", value: data.sentiment.negative },
                            { titleKey: "Report.Quick.MonitoraTeaser.Neutral", value: data.sentiment.neutral },
                            { titleKey: "Report.Quick.MonitoraTeaser.Ambivalent", value: data.sentiment.ambivalent },
                            { titleKey: "Report.Quick.MonitoraTeaser.Unknown", value: data.sentiment.unknown }
                        ])}
                        {this.renderTableCard(false, 'Report.Quick.MonitoraTeaser.MediaTitle', [
                            { titleKey: "Report.Quick.MonitoraTeaser.Online", value: data.media.online },
                            { titleKey: "Report.Quick.MonitoraTeaser.Print", value: data.media.print },
                            { titleKey: "Report.Quick.MonitoraTeaser.Tv", value: data.media.tv },
                            { titleKey: "Report.Quick.MonitoraTeaser.Radio", value: data.media.radio }
                        ])}
                    </div>}
            </div>
        )
    }

    renderTableCard = (hasPopover, headerTitleKey, rows) => {
        return (
            <div className='column is-6-fullhd is-6-widescreen is-12'>
                <div className="box scrn-h-100" style={{ padding: "0.5em" }}>
                    {hasPopover && <div style={{ float: "right" }}>
                        <BbPopover title={this.props.translate("Report.Monitora.Sentiment")} content={this.props.translate("Report.Monitora.Sentiment.Help")} placement="left" targetId="monitora-sentiment-popover">
                            <span href="#" className="icon-gray print-hidden" id="monitora-sentiment-popover" style={{ cursor: "pointer" }}>
                                <FontAwesomeIcon icon="question-circle" />
                            </span>
                        </BbPopover>
                    </div>}
                    <div style={{ padding: "0.75em" }} >
                        <UnderlinedTitle header={<Translate id={headerTitleKey} />} F marginBottom />
                        <table className="table table-report-section key-value">
                            <colgroup>
                                <col width="30%" />
                                <col width="70%" />
                            </colgroup>
                            <tbody>
                                {rows.map((row, i) => <QuickReportRow key={i} translationKey={row.titleKey} value={row.value} />)}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default withLocalize(QuickReportMonitoraTeaser);
